module.exports = __webpack_public_path__ + "img/main-bg.aaf265be.jpg";